import { c as _c } from "react/compiler-runtime";
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { NewsletterSplitTestInterface, NewsletterSplitTestUpdateInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useUpdateNewsletterSplitTestSettings = newsletterId => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== newsletterId) {
    t1 = {
      fetcherUpdateNewsletterSplitTestSettings: payload => fetcher(`${NEWSLETTERS_API}/${newsletterId}/split-test`, payload)
    };
    $[1] = fetcher;
    $[2] = newsletterId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};